// extracted by css-extract-rspack-plugin
export default {"base":"base-Qv40HY"};